import type { CommonOptions } from "bm-ui-kit";
import type { HighestLevelOfEducation } from "./types";

export const HIGHEST_LEVEL_OF_EDUCATION_OPTIONS: CommonOptions<HighestLevelOfEducation> = [
	{ label: "8 általános vagy annál kevesebb", value: "8_PRIMARY_OR_UNDER" },
	{ label: "Középfokú végzettség érettségi nélkül, szakmai végzettséggel", value: "HIGH_SCHOOL_TECHNICAL" },
	{ label: "Középfokú végzettség érettségivel", value: "HIGH_SCHOOL_GRADUATION" },
	{ label: "Főiskola vagy alapképzés", value: "COLLEGE_OR_BACHELORS" },
	{ label: "Egyetem vagy mesterképzés", value: "UNIVERSITY_OR_MASTERS" },
	{ label: "Doktori képzés", value: "DOCTORATE" },
];
